import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts';
import { format } from 'date-fns';

const DayTemperatureCompare = () => {
  const [data, setData] = useState([]);
  const [selectedDate, setSelectedDate] = useState(format(new Date(), 'yyyy-MM-dd'));
  const [loading, setLoading] = useState(false);
  const plants = ['SLS', 'Sweelee'];

  const fetchData = async (date) => {
    setLoading(true);
    try {
      const responses = await Promise.all(
        plants.map(plant =>
          axios.post('/getDayTemp', { plant, date }).then(res => res.data.data)
        )
      );

      const timestamps = responses[0]?.xAxis || [];
      const slsTemps = responses[0]?.['Temperature °C'] || [];
      const sweeleeTemps = responses[1]?.['Temperature °C'] || [];
     

     const minLength = Math.min(timestamps.length, slsTemps.length, sweeleeTemps.length);
const combined = [];

for (let i = 0; i < minLength; i++) {
  const slsRaw = slsTemps[i];
  const sweeleeRaw = sweeleeTemps[i];

  // Skip if either temperature is 0 or invalid
  if (
    typeof slsRaw !== 'number' || isNaN(slsRaw) || slsRaw === 0 ||
    typeof sweeleeRaw !== 'number' || isNaN(sweeleeRaw) || sweeleeRaw === 0
  ) {
    continue; 
  }

  combined.push({
    time: timestamps[i],
    SLS: slsRaw / 10,
    Sweelee: sweeleeRaw
  });
}

      setData(combined);
    } catch (error) {
      console.error("Error fetching temperature data", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(selectedDate);
  }, [selectedDate]);

  return (
    <div style={{backgroundColor:"white"}}>
      <h6 className="text-lg font-bold mb-4">
        Temperature Comparison of Sweelee Huawei and Trek Datalogger ({selectedDate})
      </h6>

      <input
        type="date"
        value={selectedDate}
        onChange={(e) => setSelectedDate(e.target.value)}
        className="p-2 border rounded mb-4"
        style={{
          width: '140px',
          padding: '8px',
          border: '1px solid #ccc',
          borderRadius: '6px',
          fontWeight: 'bold'
        }}
      />

      {loading ? (
        <p>Loading data...</p>
      ) : data.length === 0 ? (
        <p>No valid temperature data available for this date.</p>
      ) : (
        <ResponsiveContainer width="90%" height={400}>
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="time" />
            <YAxis label={{ value: 'Temp (°C)', angle: -90, position: 'insideLeft' }} />
            <Tooltip />
            <Legend verticalAlign="top" />
            <Line type="monotone" dataKey="SLS" name="TrekSecureDatalogger" stroke="#003366" dot={false} />
            <Line type="monotone" dataKey="Sweelee" name="HuaweiDatalogger" stroke="#8B0000" dot={false} />
          </LineChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default DayTemperatureCompare;
